<template>
  <div>
    <search></search>
    <div class="coupon_auto">
      <div class="coupon_list_title">
        <ul class="clearfix_ coupon_list_title_list">
          <li @click="changeCouponList(1)" :class="{'active':couponTitleIdx==1}" class="fl">优惠券</li>
          <li @click="changeCouponList(2)" :class="{'active':couponTitleIdx==2}" class="fl">单品券</li>
          <li @click="priceSort(1)" :class="{'active':sortType==1}" class="fl clearfix_">
            <span class="fl">券额</span>
            <i class="fl">
              <img v-show="showImg==0" :src="a02" alt="">
              <img v-show="showImg==2" :src="a03" alt="">
              <img v-show="showImg==1" :src="a04" alt="">
            </i>
          </li>
          <li @click="typeSort(2)" :class="{'active':sortType==2}" class="fl">类型</li>
          <li v-show="status==1" @click="scope(1)" :class="{'active':scopeType==1}" class="fl">
            <span class="fl">范围</span>
            <i class="fl"><img v-show="showImg_==1" :src="bottom_" alt=""><img v-show="showImg_==2" :src="top_" alt=""></i>
            <ul style="z-index:1009;" v-show="isScope">
              <li @click="changeScope(index)" v-for="(item,index) in scopeList" :key="index">{{item}}</li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="coupon_list_content">
        <div class="my_coupon_list clearfix_ new_coupon_list">
          <div v-for="(item,index) in couponList" :key="index" :style="{'width':(status==1)?'280px':'386px'}" :class="{'my_coupon_list_item_margin':status==2,'my_coupon_list_item':status==1}" class=" fl">
            <div style="width:280px;height:77px;" v-if="status==1" class="new_coupon_list_item_box">
              <div @click="goto(item.id)" class="coupon_list_goto"></div>
              <div style="width:280px;height:77px;" class="new_coupon_list_item_box_bg">
                <img style="width:280px;height:77px;" v-show="parseFloat(item.price)>0&&parseFloat(item.price)<50" :src="newCouponBg1" alt="">
                <img style="width:280px;height:77px;" v-show="parseFloat(item.price)>=50&&parseFloat(item.price)<100"  :src="newCouponBg2" alt="">
                <img style="width:280px;height:77px;" v-show="parseFloat(item.price)>=100"  :src="newCouponBg3" alt="">
              </div>
              <div class="new_coupon_list_item_box_rmb">¥</div>
              <div v-show="item.price.length==1" class="new_coupon_list_item_box_price">{{item.price}}</div>
              <div v-show="item.price.length==2" class="new_coupon_list_item_box_price_active_len2">{{item.price}}</div>
              <div v-show="item.price.length==3" class="new_coupon_list_item_box_price_active_len3">{{item.price}}</div>
              <div v-show="item.price.length>=4" class="new_coupon_list_item_box_price_active_len4">{{item.price}}</div>
              <div style="font-size:16px;top:14px;left:120px;" class="new_coupon_list_item_box_conditions"><span>{{item.condition}}</span> <span style="color:#a75212;">{{item.goodsNum}}</span> <span>{{item.method}}可用</span></div>
              <div style="font-size:14px;left:24px;top:50px;color:#fff;" class="new_coupon_list_item_box_scope">{{item.useRange}}</div>
              <div class="coupon_list_item_time">{{item.startTime}}至{{item.endTime}}</div>
              <div :style="{'color':(item.count==0?'#ccc':'#f12002')}" style="top:1px;right:1px;width:20px;height:auto;line-height:14px;background:#fff;text-align:center;cursor: pointer;border-left:1px dashed #ccc;padding:9px 4px;" @click="bondCoupon(item.id,'',item.count)" class="new_coupon_list_item_box_btn">立即领取</div>
            </div>
            <div v-if='status==2' style="width:386px;height:128px;" class="my_coupon_list_item_box clearfix_">
              <div style="width:386px;height:128px;" class="my_coupon_list_item_bg"><img style="width:386px;height:128px;" :src="myCoupon" alt=""></div>
              <div style="width:386px;height:128px;" class="my_coupon_list_item_box_fl clearfix_">
                <div @click="goToDetail(item.goodsId)" style="width:90px;height:90px;cursor: pointer;" class="my_coupon_list_item_box_fl_goodspic fl"><img style="width:90px;height:90px;" :src="item.pic" alt=""></div>
                <div style="width:150px;" class="my_coupon_list_item_box_fl_goodstxt fl">
                  <ul>
                    <li @click="goToDetail(item.goodsId)" style="margin-bottom:15px;cursor: pointer;">{{item.name}}</li>
                    <li style="margin-bottom:15px;" class="clearfix_"><b v-show="item.property1" class="fl">{{item.property1}}</b><i class="fr">x {{item.goodsNum}}{{item.unitName}}</i></li>
                    <li style="margin-bottom:15px;" class="clearfix_"><b class="fl">券后 ¥{{item.salesMoney}}</b><i class="fr">{{item.orginalMoney}}</i></li>
                  </ul>
                </div>
              </div>
              <div style="left:288px;width:96px;height:108px;" class="my_coupon_list_item_box_fr">
                <p style="margin-bottom:20px;margin-top:15px;">¥ <span>{{item.money}}</span></p>
                <!-- <p style="margin-bottom:20px;">限领{{item.count}}张</p> -->
                <p style="margin-bottom:20px;"><i @click="bondCoupon(item.id,item.goodsId,item.count)" style="width:66px;">立即领取</i></p>
              </div>
            </div>
          </div>
          <div v-show="total==0" class="noData">暂无可领优惠券！</div>
        </div>
      </div>
      <div v-show="total" class="my_coupon_pages">
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page"
            :page-size="15"
            layout="prev, pager, next, jumper"
            :total="this.total">
          </el-pagination>
        </div> 
      </div>
    </div>
  </div>
</template>
<script>
import '../../assets/css/reset.css'
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../../assets/js/public.js'
import search from '@/components/index/search'
export default {
  components:{
    search
  },
  data(){
    return {
      newCouponBg1:require('../../assets/img/coupon280_1.png'),
      newCouponBg2:require('../../assets/img/coupon280_2.png'),
      newCouponBg3:require('../../assets/img/coupon280_3.png'),
      bottom_:require('../../assets/img/bottom_.png'),
      top_:require('../../assets/img/top_.png'),
      myCoupon:require('../../assets/img/my_coupon.png'),
      a02:require('../../assets/img/a02.png'),
      a03:require('../../assets/img/a03.png'),
      a04:require('../../assets/img/a04.png'),
      scopeList:['指定全场','指定范围','指定单品'],
      couponList:[],
      page:1,
      total:null,
      tenantId:'',
      status:1,
      couponTitleIdx:1,
      scopeType:0,
      sortType:0,
      typeSortNum:0,
      priceSortNum:0,
      showImg:0,
      showImg_:1,
      useRangNum:0,
      isScope:0
    }
  },
  mounted:function(){
    this.tenantId=this.$route.query.tenantId
    this.getCouponList(this.page)
  },
  methods:{
    goto:function(id){
      var t_=this
      var href=this.$router.resolve({name:'couponDetail',query:{id:id,tenantId:t_.tenantId}})
      return window.open(href.href,'_blank')
    },
    goToDetail:function(id){
      var t_=this
      var href=t_.$router.resolve({name:'goodsdetails',query:{goodsId:id}})
      window.open(href.href,'_blank')
    },
    bondCoupon:function(id,goodsId,n){
      var t_=this
      if(n==0)return t_.$message({
        message:'不能太贪心哦~!',
        center:true,
        type:'warning'
      })
      var data0bj={
        channel:2,
        tamp:localStorage.tamp?localStorage.tamp:'',
        tenantId:t_.$route.query.tenantId,
        id:id
      }
      if(goodsId)data0bj.goodsId=goodsId
      axios.post(`${ip}formWorkInterface/bondCoupon`,Qs.stringify(data0bj)).then(res =>{
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          t_.couponList.forEach(function(item,index){
            if(item.id==res.data.id)item.count=res.data.num
          },t_)
          t_.couponList=t_.couponList
          this.$confirm(res.data.message,'提示',{
            confirmButtonText:'去看看',
            cancelButtonText:'关闭',
            distinguishCancelAndClose:true,
            type:'success'
          }).then(()=>{
            if(res.data.goodsId){
              var href=this.$router.resolve( {name:'goodsdetails',query: {goodsId:goodsId}})
              return window.open(href.href,'_blank')
            }else{
              var href=this.$router.resolve({name:'couponDetail',query:{id:res.data.id,tenantId:t_.tenantId}})
              return window.open(href.href,'_blank')
            }
          }).catch(action=>{
            
          })
        }else{
          t_.$message({
            message:res.data.message,
            center:true,
            type:'warning'
          })
        }
      })
    },
    changeScope:function(idx){
      var t_=this
      t_.useRangNum=idx+1
      t_.page=1
      t_.couponList=[]
      t_.getCouponList(t_.page)
    },
    scope:function(idx){
      var t_=this
      t_.scopeType=idx
      if(t_.showImg_==1){
        t_.showImg_=2
        t_.isScope=1
      }else{
        t_.showImg_=1
        t_.isScope=0
      }
    },
    typeSort:function(){
      var t_=this
      t_.couponList=[]
      t_.page=1
      t_.priceSortNum=0
      t_.sortType=2
      t_.scopeType=0
      if(t_.typeSortNum==0){
        t_.typeSortNum=1
      }else if(t_.typeSortNum==1){
        t_.typeSortNum=2
      }else if(t_.typeSortNum==2){
        t_.typeSortNum=1
      }
      t_.getCouponList(this.page)
    },
    priceSort:function(){
      var t_=this
      t_.couponList=[]
      t_.page=1
      t_.typeSortNum=0
      t_.sortType=1
      t_.scopeType=0
      if(t_.priceSortNum==0){
        t_.priceSortNum=1
      }else if(t_.priceSortNum==1){
        t_.priceSortNum=2
      }else if(t_.priceSortNum==2){
        t_.priceSortNum=1
      }
      t_.getCouponList(this.page)
    },
    changeCouponList:function(idx){
      var t_=this
      t_.scopeType=0
      t_.sortType=0
      t_.status=idx
      t_.couponList=[]
      t_.page=1
      t_.couponTitleIdx=idx
      t_.showImg=0
      t_.typeSortNum=0
      t_.priceSortNum=0
      t_.useRangNum=0
      t_.getCouponList(t_.page)
    },
    handleSizeChange(val){

    },
    handleCurrentChange(val) {
      this.page=val
      this.couponList=[]
      this.getCouponList(val)
    },
    getCouponList:function(page){
      var t_=this
      var data0bj={
        page:page,
        pagesize:15,
        channel:2,
        tamp:localStorage.tamp?localStorage.tamp:'',
        tenantId:t_.$route.query.tenantId,
        status:t_.status
      }
      if(t_.priceSortNum===1){
        data0bj.sortName='money'
        data0bj.sort = 1
      } else if(t_.priceSortNum===2){
        data0bj.sortName='money'
        data0bj.sort=2
      } else if(t_.priceSortNum===0&&t_.typeSortNum===0){
      } else if(t_.typeSortNum===1){
        data0bj.sortName='useRange'
        data0bj.sort=1
      } else if(t_.typeSortNum===2){
        data0bj.sortName='useRange'
        data0bj.sort=2
      }
      if(t_.useRangNum)data0bj.useRang=t_.useRangNum
      data0bj=Qs.stringify(data0bj)
      axios.post(`${ip}formWorkInterface/getPromotionCouponRuleList`,data0bj).then(res =>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          if(res.data.total==0)return t_.total=res.data.total
          if(t_.status==1){
            res.data.promotionCouponRuleRs.forEach(function(item,index){
              item.price=item.price.toString()
            },t_)
          }
          t_.couponList=res.data.promotionCouponRuleRs,
          t_.status=res.data.status
          t_.total=res.data.total
          if(res.data.sort==1&&res.data.sortName=='money'){
            t_.showImg=1
          }else if(res.data.sort==2&&res.data.sortName=='money'){
            t_.showImg=2
          }
        }
      })
    },
  }
}
</script>
<style>
  .coupon_auto{
    width: 1200px;
    margin: 0 auto;
  }
  .coupon_list_title{
    padding: 10px 15px;
    border: 1px solid #e4e4e4;
    background: #f2f2f2;
    margin-top: 20px;
  }
  .coupon_list_title_list li{
    width: 80px;
    height: 22px;
    border:1px solid #e4e4e4;
    background: #fff;
    text-align: center;
    line-height: 22px;
    margin-right: 10px;
    cursor: pointer;
  }
  .coupon_list_title_list li:nth-child(3) i{
    width: 7px;
    height: 11px;
    margin: 6px 0 0 6px;
  }
  .coupon_list_title_list li:nth-child(3) span{
    margin-left: 22px;
  }
  .coupon_list_title_list li:nth-child(3) i img{
    width: 7px;
    height: 11px;
  }
  .coupon_list_title_list li:nth-child(5){
    position: relative;
  }
  .coupon_list_title_list li:nth-child(5) span{
    margin-left: 20px;
  }
  .coupon_list_title_list li:nth-child(5) i{
    width:15px;
    height:15px;
    margin: 4px 0 0 5px;
  }
  .coupon_list_title_list li:nth-child(5) i img{
    width:15px;
    height:15px;
  }
  .coupon_list_title_list li:nth-child(5) ul{
    position: absolute;
    top:22px;
    left:-1px;
    z-index: 9;
    color:#2c3e50;
  }
  .coupon_list_title_list .active{
    color:#ff5f12;
  }
  .my_coupon_list{
    padding: 20px 0;
  }
  .new_coupon_list .my_coupon_list_item{
    width: 330px;
    margin: 0 26px 20px 0;
  }
  .new_coupon_list .my_coupon_list_item:nth-child(4n){
    margin: 0 0 20px 0;
  }
  .new_coupon_list .my_coupon_list_item_margin{
    margin: 0 21px 20px 0;
  }
  .new_coupon_list .my_coupon_list_item_margin:nth-child(3n){
    margin: 0 0 20px 0;
  }
  .my_coupon_list_item_box{
    width: 330px;
    height: 110px;
    position: relative;
  }
  .my_coupon_list_item_bg{
    position: absolute;
    top:0;
    left:0;
  }
  .my_coupon_list_item_time{
    margin-left: 10px;
    margin-bottom: 15px;
  }
  .my_coupon_list_item_box_fl{
    width: 248px;
    padding-top: 20px;
    position: absolute;
    left: 0;
    top:0;
  }
  .my_coupon_list_item_box_fl p{
    margin-bottom: 10px;
    width: 220px;
    margin-left: 16px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .my_coupon_list_item_box_fl p:first-child{
    font-size:16px;
  }
  .my_coupon_list_item_box_fl p span{
    display: inline-block;
    height: 24px;
    line-height: 24px;
    background:#fff2eb;
    color:#ff5f12;
    padding: 0 10px;
  }
  .my_coupon_list_item_box_fr{
    width: 82px;
    position: absolute;
    left: 249px;
    top:0;
    padding-top: 20px;
  }
  .my_coupon_list_item_box_fr p{
    text-align: center;
    margin-bottom: 13px;
    color:#f12002;
  }
  .my_coupon_list_item_box_fr p span{
    font-size:20px;
  }
  .my_coupon_list_item_box_fr i{
    cursor: pointer;
    display: inline-block;
    width: 50px;
    height: 24px;
    color:#fff;
    line-height: 24px;
    border-radius: 5px;
    background:#f12002;
  }
  .my_coupon_list_item_box_fl_goodspic{
    width: 70px;
    height: 70px;
    margin-left: 16px;
  }
  .my_coupon_list_item_box_fl_goodspic img{
    width: 70px;
    height: 70px;
  }
  .my_coupon_list_item_box_fl_goodstxt{
    margin-left: 15px;
    width: 130px;
  }
  .my_coupon_list_item_box_fl_goodstxt li{
    margin-bottom: 8px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .my_coupon_list_item_box_fl_goodstxt li:first-child{
    font-size:16px;
  }
  .my_coupon_list_item_box_fl_goodstxt li:nth-child(2) b{
    padding: 0 10px;
    background:#fff2eb;
    color:#ff5f12;
    height: 24px;
    line-height: 24px;
  }
  .my_coupon_list_item_box_fl_goodstxt li:nth-child(2) i{
    height: 24px;
    line-height: 24px;
  }
  .my_coupon_list_item_box_fl_goodstxt li:last-child b{
    color:#f12002;
  }
  .my_coupon_list_item_box_fl_goodstxt li:last-child i{
    text-decoration:line-through;
    color:#bababa;
  }
  .new_coupon_list_item_box{
    width: 380px;
    height: 104px;
    position: relative;
  }
  .new_coupon_list_item_box_bg{
    position: absolute;
    top: 0;
    left:0;
    width: 380px;
    height: 104px;
  }
  .new_coupon_list .new_coupon_list_item_box_rmb{
    position: absolute;
    top:28px;
    left:15px;
    color:#fff;
    font-size: 20px;
  }
  .new_coupon_list .new_coupon_list_item_box_price{
    /* width: ; */
    position: absolute;
    top:10px;
    left:42px;
    color:#fff;
    font-size: 42px;
  }
  .new_coupon_list .new_coupon_list_item_box_price_active_len2{
    position: absolute;
    top:10px;
    left:30px;
    color:#fff;
    font-size: 42px;
  }
  .new_coupon_list .new_coupon_list_item_box_price_active_len3{
    position: absolute;
    top:17px;
    left:30px;
    color:#fff;
    font-size: 34px;
  }
  .new_coupon_list .new_coupon_list_item_box_price_active_len4{
    position: absolute;
    top:22px;
    left:28px;
    color:#fff;
    font-size: 28px;
  }
  .new_coupon_list_item_box_conditions{
    width: 115px;
    position: absolute;
    top:18px;
    left:190px;
    font-size:20px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    font-weight: 900;
  }
  .new_coupon_list_item_box_conditions span{
    color:#66604a;
  }
  .new_coupon_list_item_box_scope{
    position: absolute;
    top:57px;
    left:190px;
    font-size:16px;
    height: 22px;
    line-height: 22px;
  }
  .new_coupon_list_item_box_btn{
    position: absolute;
    top:57px;
    height: 22px;
    width: 82px;
    right: 24px;
    color:#f12002;
  }
  .noData{
    text-align: center;
    padding: 30px 0;
  }
  .coupon_list_item_time{
    width: 115px;
    position: absolute;
    top:50px;
    left:120px;
    font-size:14px;
    color:#ababab;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .coupon_list_goto{
    width: 250px;
    height: 77px;
    position: absolute;
    top:0;
    left:0;
    z-index: 9;
    cursor: pointer;
  }
  .my_coupon_pages{
    text-align: center;
    padding-bottom: 10px;
  }
  .my_coupon_pages .el-pagination__jump{
    margin-top: -9px;
  }
  .my_coupon_pages .el-pagination__jump .el-pagination__editor{
    top:9px;
  }
</style>



// WEBPACK FOOTER //
// src/components/coupon/coupon_list.vue